
export const LocaleConstants = {
	LOCALSTORAGE_KEYS: {
		DEFAULT_LOCAL: 'default_locale',
	},
	COOKIE_KEY: 'locale',
}